/**
 * StatCard — compact stat chip with a colored left accent.
 * Shared by Dashboard and Job Sheet headers.
 */

export default function StatCard({ label, count, accent }) {
  return (
    <div
      className="orin-stat-card flex items-center gap-3 px-4 py-2.5 rounded-lg bg-card border border-border-base"
      style={{ borderLeftWidth: 3, borderLeftColor: accent }}
    >
      <span className="text-xl font-bold text-ink leading-none tabular-nums">{count}</span>
      <span className="text-[11px] text-muted font-medium leading-tight">{label}</span>
    </div>
  );
}
